export const TrendAnalysisConstants = {
  sortByPeriod: 'Sort By Period',
  settings: 'Settings',
  downloadData: 'Download Data',
};
